module.exports = __webpack_public_path__ + "static/media/_LOGO_CONTOUR_BLANC.da9bf1fe.svg";